(() => {
  const hero = document.querySelector('[data-hero]');
  if (!hero) return;

  const slides = hero.querySelectorAll('[data-slide]');
  const bgs = hero.querySelectorAll('[data-bg]');
  const total = slides.length;
  if (!total) return;

  const autoplay = hero.dataset.autoplay === 'true';
  const duration = (parseInt(hero.dataset.duration, 10) || 6) * 1000;

  let current = 0;
  let animating = false;
  let timer = null;

  const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
  const counterCurrent = hero.querySelector('[data-hero-counter-current]');
  const counterTotal = hero.querySelector('[data-hero-counter-total]');
  const progress = hero.querySelector('[data-hero-progress]');
  const logotype = hero.querySelector('[data-hero-logotype]');

  const easeOut = 'cubic-bezier(0.16, 1, 0.3, 1)';
  const easeIn = 'cubic-bezier(0.55, 0.06, 0.68, 0.19)';

  const animText = (slideEl, enter) => {
    const items = Array.from(slideEl.querySelectorAll('[data-hero-text]'));
    if (!items.length) return Promise.resolve();
    const anims = items.map((el, i) =>
      el.animate(
        enter
          ? [
              { opacity: 0, transform: 'translateY(36px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ]
          : [
              { opacity: 1, transform: 'translateY(0)' },
              { opacity: 0, transform: 'translateY(-24px)' }
            ],
        {
          duration: enter ? 550 : 350,
          delay: enter ? i * 80 : i * 40,
          fill: 'both',
          easing: enter ? easeOut : easeIn
        }
      )
    );
    return Promise.all(anims.map((a) => a.finished));
  };

  const updateUI = () => {
    dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === current);
      d.setAttribute('aria-current', i === current ? 'true' : 'false');
    });
    if (counterCurrent) counterCurrent.textContent = String(current + 1).padStart(2, '0');
    if (counterTotal) counterTotal.textContent = String(total).padStart(2, '0');
  };

  const resetTimer = () => {
    if (timer) clearInterval(timer);
    if (autoplay && total > 1) {
      timer = setInterval(() => goTo(current + 1), duration);
    }
    if (progress) {
      progress.style.animation = 'none';
      void progress.offsetWidth;
      progress.style.animation = '';
    }
  };

  const setBg = (index) => {
    bgs.forEach((bg) => {
      bg.classList.toggle('is-active', Number(bg.dataset.bg) === index);
    });
  };

  const goTo = (next) => {
    if (animating) return;
    const target = ((next % total) + total) % total;
    if (target === current) return;
    animating = true;

    const out = slides[current];
    const inn = slides[target];

    animText(out, false).then(() => {
      out.setAttribute('hidden', '');
      inn.removeAttribute('hidden');
      current = target;
      setBg(current);
      updateUI();
      resetTimer();
      animText(inn, true).then(() => {
        animating = false;
      });
    });
  };

  const animateEntrance = () => {
    if (logotype) {
      logotype.animate(
        [{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }],
        { duration: 1200, fill: 'both', easing: easeOut }
      );
    }
    if (slides[0]) {
      animText(slides[0], true);
    }
    setBg(0);
    updateUI();
    resetTimer();
  };

  document.addEventListener('click', (e) => {
    const prev = e.target.closest('[data-hero-prev]');
    const next = e.target.closest('[data-hero-next]');
    const dot = e.target.closest('[data-hero-dot]');
    if (prev) goTo(current - 1);
    else if (next) goTo(current + 1);
    else if (dot) goTo(Number(dot.dataset.heroDot));
  });

  document.addEventListener('keydown', (e) => {
    if (e.target.closest('[data-hero]') === null) return;
    if (e.key === 'ArrowLeft') goTo(current - 1);
    if (e.key === 'ArrowRight') goTo(current + 1);
  });

  document.addEventListener('DOMContentLoaded', () => {
    animateEntrance();
  });
})();
